const colors = {
  hashTagBgColor: "#c2c2c2",
  hashTagBorderColor: "#949494",
  hashTagTextColor: "#f5f5f5",
};

export default colors;
